export const config = {
    namespaced: true,
    state: {
        pageTitle: ''
    },

    getters: {
        pageTitle: state => state.pageTitle
    },
    mutations: {
        setPageTitle(state, value) {
            state.pageTitle = value;
        }
    },
    actions: {
        onSetPageTitle({commit}, value) {
            commit('setPageTitle', value);
        },
    }

};
